import { render } from "./BaseSimpleSwitch.vue?vue&type=template&id=66c0f1d8&ts=true"
import script from "./BaseSimpleSwitch.vue?vue&type=script&lang=ts"
export * from "./BaseSimpleSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__